import React from "react";
import { IStyledSVGIconProps, StyledSVGIcon } from "./icon.style";

export const GearCircleIcon: React.FC<IStyledSVGIconProps> = (props) => {
  return (
    <StyledSVGIcon
      version="1.1"
      id="icons"
      xmlns="http://www.w3.org/2000/svg"
      xlinkHref="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      height="24"
      viewBox="0 0 48 48"
      width="24"
      style={{ enableBackground: "new 0 0 47.9 42" }}
      xmlSpace="preserve"
      {...props}
    >
      <g>
        <path
          d="M9.9,21c0-7.7,6.3-14,14-14c4.8,0,9.3,2.5,11.9,6.5l1.7-1.1c-4.7-7.5-14.6-9.7-22.1-5c-4.7,2.9-7.5,8-7.5,13.5
		v2h1.3l-2.4,4.2l-3-4.2h1v-2c0-10.5,8.5-19,19-19V0c-11.6,0-21,9.4-21,21H0l7,9.8l5.7-9.8H9.9z"
        />
        <path d="M36.6,4.3c-0.7-0.5-1.4-1-2.1-1.4l-1,1.7c0.7,0.4,1.3,0.8,1.9,1.3L36.6,4.3z" />
        <path d="M32.4,1.8c-0.7-0.3-1.3-0.5-2-0.8l-0.6,1.9c0.6,0.2,1.2,0.4,1.8,0.7L32.4,1.8z" />
        <path d="M28,0.4c-0.6-0.1-1.3-0.2-2-0.3l-0.2,2c0.6,0.1,1.2,0.2,1.8,0.3L28,0.4z" />
        <path
          d="M40.8,11.2L35.2,21h2.7c0.1,7.7-6.1,13.9-13.8,14c-4.8,0-9.3-2.4-11.9-6.5l-1.7,1.1c4.7,7.4,14.5,9.7,21.9,5
		c4.7-2.9,7.5-8.1,7.5-13.6v-2h-1.3l2.3-4.2l3,4.2h-1.1v2c0,10.5-8.5,19-18.9,19v2c11.6,0,20.9-9.4,20.9-21h3L40.8,11.2z"
        />
        <path d="M11.3,37.7c0.7,0.5,1.4,1,2.1,1.4l1-1.7c-0.7-0.4-1.3-0.8-1.9-1.3L11.3,37.7z" />
        <path d="M15.6,40.2c0.7,0.3,1.3,0.5,2,0.8l0.6-1.9c-0.6-0.2-1.2-0.4-1.8-0.7L15.6,40.2z" />
        <path d="M19.9,41.6c0.7,0.1,1.3,0.2,2,0.3l0.2-2c-0.6-0.1-1.2-0.2-1.8-0.3L19.9,41.6z" />
        <path
          d="M24,17c-2.2,0-4,1.8-4,4s1.8,4,4,4s4-1.8,4-4S26.2,17,24,17z M24,23c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2
		S25.1,23,24,23z"
        />
        <path
          d="M31.1,13.4l-2.2,1.3c-0.6-0.5-1.3-0.8-2-1.1V11h-6v2.6c-0.7,0.3-1.3,0.7-1.9,1.1l-2.2-1.3l-3,5.2l2.2,1.3
		c0,0.4,0,0.7,0,1.1s0,0.7,0.1,1.1l-2.3,1.3l3,5.2l2.3-1.3c0.6,0.5,1.2,0.8,1.9,1.1V31h6v-2.6c0.7-0.3,1.3-0.7,1.9-1.1l2.2,1.3
		l3-5.2l-2.2-1.3C32,21.7,32,21.4,32,21s0-0.7-0.1-1.1l2.2-1.3L31.1,13.4z M29.8,19.6c0.1,0.5,0.2,0.9,0.2,1.4s-0.1,0.9-0.2,1.4
		l-0.2,0.7l1.8,1l-1,1.7l-1.8-1l-0.5,0.5c-0.7,0.6-1.5,1.1-2.4,1.4L25,27v2h-2v-2.1l-0.7-0.2c-0.9-0.3-1.7-0.7-2.4-1.4l-0.5-0.5
		l-1.8,1l-1-1.7l1.8-1l-0.2-0.7C18.1,21.9,18,21.5,18,21s0.1-0.9,0.2-1.4l0.2-0.7l-1.8-1l1-1.7l1.8,1l0.5-0.5
		c0.7-0.7,1.5-1.1,2.4-1.4L23,15v-2h2v2l0.7,0.2c0.9,0.3,1.7,0.8,2.4,1.4l0.5,0.5l1.7-1l1,1.7l-1.7,1L29.8,19.6z"
        />
      </g>
    </StyledSVGIcon>
  );
};
